/* istanbul ignore file */
import { parsers } from '@codegrade/utils';
import { AccessPassCouponWithCode } from './AccessPassCouponWithCode';
import { AccessPassCouponWithoutCode } from './AccessPassCouponWithoutCode';
const AccessPassCouponParser = 
/* #__PURE__ */ /* #__PURE__ */ parsers.taggedUnion('type', [
    ['coupon-with-code', AccessPassCouponWithCode],
    ['coupon-without-code', AccessPassCouponWithoutCode],
]);
export const AccessPassCoupon = AccessPassCouponParser;
